import { useEffect, useState } from 'react';
import axios from 'axios';
import stylesSpec from './sportstaetteForm.module.css';
import stylesDefault from '../default.module.css';
import { showErrorToast } from '../../../../code/ToastHelper';
import { shouldSkipGeneratingVar } from '@mui/material';

export default function SportstaetteForm({ sportstaette, onSave, onClose }) {
    const [images, setImages] = useState([]);
    // const [newImage, setNewImage] = useState(null);

    const [formData, setFormData] = useState({
        bezeichnung: '',
        name: '',
        link_name: '',
        maps_link: '',
        kurztext: '',
        strasse: '',
        plz: '',
        stadt: '',
        bushaltestelle: '',
        buslinien: '',
        anfahrt: '',
        ausstattung: '',
        verbote: '',
    });
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        if (!sportstaette || !sportstaette.id) {
            return;
        }

        axios.get(`/api/sportstaetten/images/${sportstaette.id}`)
            .then(res => {
                const data = res.data;
                if (Array.isArray(data)) {
                    setImages(data);
                } else if (data.images && Array.isArray(data.images)) {
                    setImages(data.images);
                } else {
                    setImages([]);
                }
            })
            .catch(err => console.error("Bilder laden fehlgeschlagen:", err));
    }, [sportstaette]);
    useEffect(() => {
        if (sportstaette) {
            setFormData({
                id: sportstaette.id || '',
                bezeichnung: sportstaette.bezeichnung || '',
                name: sportstaette.name || '',
                link_name: sportstaette.link_name || '',
                maps_link: sportstaette.maps_link || '',
                kurztext: sportstaette.kurztext || '',
                strasse: sportstaette.strasse || '',
                plz: sportstaette.plz || '',
                stadt: sportstaette.stadt || '',
                bushaltestelle: sportstaette.bushaltestelle || '',
                buslinien: sportstaette.buslinien || '',
                anfahrt: sportstaette.anfahrt || '',
                ausstattung: sportstaette.ausstattung || '',
                verbote: sportstaette.verbote || '',

            });
        }
    }, [sportstaette]);

    const handleImageUpload = async (e) => {
        const file = e.target.files[0];
        if (!file || !sportstaette?.id) return;

        const formData = new FormData();
        formData.append('link_id', sportstaette.id);
        formData.append('image', file);

        try {
            const res = await axios.post('/api/sportstaetten/images', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            setImages(prev => [...prev, res.data.image]);
        } catch (err) {
            console.error("Fehler beim Hochladen:", err);
            showErrorToast("Bild konnte nicht hochgeladen werden.");
        }
    };
    const handleImageDelete = async (id) => {
        try {
            await axios.delete(`/api/sportstaetten/images/${id}`);
            setImages(prev => prev.filter(img => img.id !== id));
        } catch (err) {
            console.error("Fehler beim Löschen:", err);
            showErrorToast("Bild konnte nicht gelöscht werden!");
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const payload = {
            ...formData,
            buslinien: formData.buslinien.split(',').map(s => s.trim()).join(', '),
            anfahrt: formData.anfahrt.split('\n').map(s => s.trim()).filter(Boolean).join('\n'),
            ausstattung: formData.ausstattung.trim().split(',').map(s => s.trim()).join(', '),
            verbote: formData.verbote.split(',').map(s => s.trim()).join(', ')
        };

        try {
            if (sportstaette && sportstaette.id) {
                await axios.put(`/api/sportstaetten/${sportstaette.id}`, payload);
                onSave(sportstaette.id, 'update');
            } else {
                const res = await axios.post('/api/sportstaetten/', payload);
                onSave(res.data.id, 'create');
            }
        } catch (err) {
            console.error('Fehler beim Speichern:', err);
            showErrorToast("Fehler beim Speichern der Sportstätte.")
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={stylesSpec.modalOverlay}>
            <form className={stylesSpec.modalForm} onSubmit={handleSubmit}>
                <h2>{sportstaette?.id ? 'Sportstätte bearbeiten' : 'Neue Sportstätte anlegen'}</h2>

                <button
                    type="button"
                    onClick={onClose}
                    className={stylesSpec.closeButton}
                    aria-label="Modal schließen"
                >
                    ×
                </button>

                <label>
                    Bezeichnung (optional):
                    <input name="bezeichnung" value={formData.bezeichnung} onChange={handleChange} />
                </label>

                <label>
                    Name:
                    <input name="name" value={formData.name} onChange={handleChange} required />
                </label>
                <label>
                    Link-Name:
                    <input name="link_name" value={formData.link_name} onChange={handleChange} requiered />
                </label>

                <label>
                    Google Maps Link:
                    <input name="maps_link" value={formData.maps_link} onChange={handleChange} />
                </label>

                <label>
                    Kurztext:
                    <textarea name="kurztext" value={formData.kurztext} onChange={handleChange} rows={3} />
                </label>

                <label>
                    Straße:
                    <input name="strasse" value={formData.strasse} onChange={handleChange} />
                </label>

                <label>
                    PLZ:
                    <input name="plz" value={formData.plz} onChange={handleChange} />
                </label>

                <label>
                    Stadt:
                    <input name="stadt" value={formData.stadt} onChange={handleChange} />
                </label>

                <label>
                    Bushaltestelle:
                    <input name="bushaltestelle" value={formData.bushaltestelle} onChange={handleChange} />
                </label>

                <label>
                    Buslinien (kommagetrennt):
                    <input name="buslinien" value={formData.buslinien} onChange={handleChange} />
                </label>

                <label>
                    Anfahrt (je Schritt eine Zeile):
                    <textarea name="anfahrt" value={formData.anfahrt} onChange={handleChange} rows={4} />
                </label>
                <label>
                    Ausstattungen (kommagetrennt):
                    <textarea name="ausstattung" value={formData.ausstattung} onChange={handleChange} />
                </label>
                <label>
                    Verbote (kommagetrennt):
                    <input name="verbote" value={formData.verbote} onChange={handleChange} />
                </label>
                <label>
                    Bilder:
                    <input type="file" accept="image/*" onChange={handleImageUpload} disabled={!sportstaette?.id} />
                </label>

                <div className={stylesSpec.imagePreview}>
                    {images.map(img => (
                        <div key={img.id} className={stylesSpec.imageWrapper}>
                            <img src={`${img.image_path}`} alt="Vorschau" />
                            <button
                                type="button"
                                onClick={() => handleImageDelete(img.id)}
                                className={stylesDefault.redButton}
                            >
                                ✕
                            </button>
                        </div>
                    ))}
                </div>

                <div className={stylesDefault.formButtons}>
                    <button className={stylesDefault.blueButton} type="submit" disabled={loading}>
                        {loading ? 'Speichert...' : sportstaette?.id ? 'Aktualisieren' : 'Erstellen'}
                    </button>
                    <button className={stylesDefault.redButton} type="button" onClick={onClose} disabled={loading}>
                        Abbrechen
                    </button>
                </div>
            </form>
        </div>
    );
}
